import React, { FC, useEffect, useState } from "react";
import { getInidicators, Indicators } from "../../apis/indicators";
import { useMunicipalityHome } from "../../providers/municipality-home-provider";
import {
  IndicatorsSection,
  IndicatorsSectionProps,
} from "./indicators-section";

export const IndicatorsSectionContainer: FC = () => {
  const [indicators, setIndicators] = useState<Indicators | null>(null);
  const { codIbgeMunicipio } = useMunicipalityHome();

  useEffect(() => {
    const loadIndicators = async () => {
      try {
        const result = await getInidicators(codIbgeMunicipio);
        setIndicators(result);
      } catch (error) {
        console.error("Error loading indicators:", error);
        setIndicators(null);
      }
    };

    loadIndicators();
  }, [codIbgeMunicipio]);

  if (!indicators) return null;

  const indicatorsSectionProps: IndicatorsSectionProps = {
    data: {
      availableServices: indicators.availableServices,
      digitalServices: indicators.digitalServices,
      citizensRegistered: indicators.citizensRegistered,
    },
  };

  return <IndicatorsSection {...indicatorsSectionProps} />;
};
